const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.main {
  width: 90%;
  padding: 20px 10px;
  margin: 0px auto;
  margin-top: 4rem;
}

.greet-main {
  width: 90%;
  padding: 20px 10px;
  margin: 0px auto;
  margin-top: 2rem;
}

.greeting-main {
  display: flex;
}

.subTitle {
  color: #868e96 !important;
}

.greeting-main {
  display: flex;
  align-items: center;
  justify-content: center;
}

.greeting-main > * {
  flex: 1;
  margin-bottom: 30px;
}

.button-greeting-div {
  display: flex;
  margin-top: 20px;
}

.greeting-text {
  font-size: 70px;
  line-height: 1.1;
  color: #000000 !important;
}

.greeting-text-p {
  font-size: 30px;
  line-height: 40px;
}

.greeting-image-div > img {
  max-width: 100%;
  height: auto;
}

.profile-image:hover {
  scale: 1.05;
  transition: 0.3s ease-out;
}

.profile-image {
  border-radius: 50%;
  margin-left: auto;
  width: 100%;
  max-width: 350px;
  height: auto;
  box-shadow: rgba(0, 0, 0, 0.1) 0 30px 30px -30px;
  transition: all 0.3s ease-out;
}

.profile-image:hover {
  box-shadow: none;
}

.image-content-profile {
  text-align: center;
  max-width: 600px;
  height: auto;
}

.wave-emoji {
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
  animation-name: wave;
  display: inline-block;
  transform-origin: 70% 70%;
}

@keyframes wave {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(-10deg);
  }
  20% {
    transform: rotate(12deg);
  }
  30% {
    transform: rotate(-10deg);
  }
  40% {
    transform: rotate(9deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
/* Media Query */
@media (max-width: 1380px) {
  .greeting-text {
    font-size: 50px;
  }
  .greeting-text-p {
    font-size: 20px;
  }
}
@media (max-width: 768px) {
  .button-greeting-div {
    justify-content: space-around;
  }
  .greeting-text {
    font-size: 30px;
    text-align: center;
  }
  .greeting-text-p {
    font-size: 16px;
    line-height: normal;
    text-align: center;
  }
  .greeting-main {
    flex-direction: column;
  }
  .greeting-image-div {
    height: 256px;
  }
  .image-content-profile {
    order: -1 !important;
  }
  .profile-image {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 200px;
    height: auto;
  }
  .profile-image:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0 50px 50px -50px;
    transition: 0.3s ease-out;
  }
  .image-content-profile {
    margin-left: auto;
    margin-right: auto;
  }
}
@media (max-width: 320px) {
  .main {
    width: auto;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
